import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 3C7.58172 3 4 6.58172 4 11C4 12.4802 4.40147 13.865 5.10156 15.0469L3.5 19H6.75L7.5 17.5H16.5L17.25 19H20.5L18.8984 15.0469C19.5985 13.865 20 12.4802 20 11C20 6.58172 16.4183 3 12 3ZM6.5 11C6.5 7.96243 8.96243 5.5 12 5.5C15.0376 5.5 17.5 7.96243 17.5 11H6.5Z'
    />
  </>,
  'Helmet'
)
